import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiGet, apiSend } from './api'

export interface Profile {
  userId: string
  email: string
  displayName: string
  twoFactorEnabled: boolean
  recoveryCodesLeft: number
  roles: string[]
  createdAt: string
}

export interface TwoFactorSetup {
  sharedKey: string
  authenticatorUri: string
}

const profileKey = ['profile'] as const

export function useProfile() {
  return useQuery({
    queryKey: profileKey,
    queryFn: () => apiGet<Profile>('/api/profile'),
  })
}

export function useStartMfaSetup() {
  return useMutation({
    mutationFn: () => apiSend<TwoFactorSetup>('/api/profile/mfa/setup', 'POST'),
  })
}

export function useConfirmMfaSetup() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (code: string) =>
      apiSend<{ recoveryCodes: string[] }>('/api/profile/mfa/confirm', 'POST', { code }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: profileKey }),
  })
}

export function useDisableMfa() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (code: string) => apiSend<null>('/api/profile/mfa/disable', 'POST', { code }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: profileKey }),
  })
}
